<template>
  <div class="sideBar" :class="{ closed: isToggleSideBar }" v-if="isPermissions">
    <ul>
      <router-link
        v-if="isPermissions.support_payments"
        to="./dashboard"
        @click="mobileCloseSideBar"
      >
        <img src="../../assets/images/table.svg" />
        <p>Payouts</p>
      </router-link>
      <router-link v-if="isPermissions.admin_payments" to="./deposits">
        <img src="../../assets/images/depositsIcon.png" />
        <p>Deposits</p>
      </router-link>
      <!--            <router-link to="./withdraw" v-if="isPermissions.admin_payments" @click="mobileCloseSideBar">-->
      <!--                <img src="../../assets/images/payment.png"/>-->
      <!--                <p>Withdraw</p>-->
      <!--            </router-link>-->
      <router-link
        to="./accounting"
        v-if="isPermissions.acc_once_payments"
        @click="mobileCloseSideBar"
      >
        <img src="../../assets/images/accounting.png" />
        <p>Accounting</p>
      </router-link>
      <router-link to="./exchange" v-if="isPermissions.admin_payments" @click="mobileCloseSideBar">
        <img src="../../assets/images/exchange.svg" />
        <p>Exchange</p>
      </router-link>
      <router-link to="./items" @click="mobileCloseSideBar" v-if="isPermissions.read_user_items">
        <img src="../../assets/images/items.svg" />
        <p>Items</p>
      </router-link>
      <router-link to="./anti-scam" @click="mobileCloseSideBar" v-if="isPermissions.bot_check">
        <img src="../../assets/images/antisacm.png" />
        <p>Anti-Scam</p>
      </router-link>
      <router-link
        to="./fraud-registry"
        @click="mobileCloseSideBar"
        v-if="isPermissions.fraud_support_read"
      >
        <img src="../../assets/images/fraud.png" />
        <p>Fraud-registry</p>
      </router-link>
      <router-link to="./rns" @click="mobileCloseSideBar" v-if="isPermissions.rns">
        <img src="../../assets/images/rns.svg" />
        <p>RNS</p>
      </router-link>
      <router-link
        to="./mm2-beta"
        @click="mobileCloseSideBar"
        v-if="isPermissions.mm_beta_test_admin"
      >
        <img src="../../assets/images/mm2icon.png" />
        <p>MM2-Beta</p>
      </router-link>
      <router-link to="./goods" @click="mobileCloseSideBar" v-if="isPermissions.goods_admin">
        <img src="../../assets/images/PetIcon.svg" />
        <p>Goods</p>
      </router-link>
      <router-link to="./descriptions" @click="mobileCloseSideBar" v-if="isPermissions.goods_admin">
        <img src="../../assets/images/PetIcon.svg" />
        <p>Descriptions</p>
      </router-link>
      <router-link to="./balances" @click="mobileCloseSideBar" v-if="isPermissions.balances">
        <img src="../../assets/images/balance.png" />
        <p>Balances</p>
      </router-link>
      <router-link to="./balances-multi" @click="mobileCloseSideBar" v-if="isPermissions.balances">
        <img src="../../assets/images/balance.png" />
        <p>Balances Multi</p>
      </router-link>
      <router-link to="./superpasses" @click="mobileCloseSideBar" v-if="isPermissions.superpasses">
        <img src="../../assets/images/balance.png" />
        <p>Superpasses & Gifts</p>
      </router-link>
      <router-link to="./logs" @click="mobileCloseSideBar" v-if="isPermissions.super">
        <img src="../../assets/images/logs.png" />
        <p>Logs</p>
      </router-link>
      <router-link to="./rights" @click="mobileCloseSideBar" v-if="isPermissions.super">
        <img src="../../assets/images/rights.png" />
        <p>Access-rights</p>
      </router-link>
      <router-link to="./reviews" @click="mobileCloseSideBar" v-if="isPermissions.manage_reviews">
        <img src="../../assets/images/reviews.svg" />
        <p>Reviews</p>
      </router-link>
    </ul>
    <div
      class="sideBar__limit"
      v-if="isPermissions.admin_payments || isPermissions.acc_once_payments"
    >
      <h2>Daily limits:</h2>
      <Loader v-if="limitLoader" />
      <p v-if="!limitLoader">
        RUB:
        {{ isCurrentDailyLimit['rub'] - correctSpent('rub') }}
        ₽
      </p>
      <p v-if="!limitLoader">
        EUR:
        {{ isCurrentDailyLimit['eur'] - correctSpent('eur') }}
        €
      </p>
      <p v-if="!limitLoader">
        USD:
        {{ isCurrentDailyLimit['usd'] - correctSpent('usd') }}
        $
      </p>
    </div>
    <div class="sideBar__limit" v-if="isPermissions.manage_user_items">
      <h2>
        Daily limit items:<br />
        {{ isItemsLimit.usd }}$
      </h2>
      <p>Wasted: {{ isWastedItems }}$</p>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader/Loader.vue'
import './sideBar.scss'

export default {
  name: 'SideBar',
  data() {
    return {
      limitLoader: false
    }
  },
  components: {
    Loader
  },
  computed: {
    isToggleSideBar() {
      return this.$store.state.toggleSideBar
    },
    isPermissions() {
      return this.$store.state.permissions
    },
    isCurrentDailyLimit() {
      return this.$store.state.currentDailyLimit
    },
    isItemsLimit() {
      return this.$store.state.itemsExchangeLimit
    },
    isWastedItems() {
      return this.$store.state.wastedLimitItems
    },
    isDailyLimit() {
      return this.$store.state.currentDailyLimit
    },
    isCurrentSpent() {
      return this.$store.state.currentSpent
    }
  },
  created() {
    this.initListeners()
    this.mobileCloseSideBar()
  },
  watch: {
    isPermissions: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getItemsInfo()
          this.getWithdrawSum()
        }
      },
      immediate: true
    }
  },
  destroyed() {
    this.initListeners()
  },
  methods: {
    getItemsInfo() {
      if (!this.isPermissions.manage_user_items || this.isWastedItems) {
        return
      }
      fetch(`https://auth.apineural.com/api/user/admin-items-info`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.$store.state.tokens.access}`
        }
      })
        .then((res) => res.json())
        .then((data) => {
          const wastedItems = data.wasted.toFixed(2)
          this.$store.commit('setWastedLimitItems', wastedItems)
        })
    },
    getWithdrawSum() {
      if (!this.isPermissions.admin_payments || Object.keys(this.isCurrentSpent).length) {
        return
      }
      this.limitLoader = true
      fetch(`https://payments.neuralgeneration.com/api/v1/withdrawals/admin-withdrawals-sum`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.$store.state.tokens.access}`
        }
      })
        .then((res) => res.json())
        .then((data) => {
          this.$store.commit('setCurrentSpent', data)
          this.limitLoader = false
        })
    },
    correctSpent(currency) {
      if (!this.isPermissions.admin_payments) {
        return 0
      } else {
        return this.isCurrentSpent[currency]
      }
    },
    mobileCloseSideBar() {
      if (window.innerWidth < 600) {
        this.$store.dispatch('openSideBar')
      }
    },
    closeByClickingOutSideBar(event) {
      const path = event.path || (event.composedPath && event.composedPath())
      if (
        event &&
        !path.find((div) => div.classList && div.classList.contains('logo-header__burger')) &&
        window.innerWidth < 500
      ) {
        this.$store.commit('setToggleSideBar', 'false')
      }
    },
    initListeners() {
      document.addEventListener('click', this.closeByClickingOutSideBar)
    }
  }
}
</script>
